module.exports = __webpack_public_path__ + "static/media/racefit.503fc256.png";